import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { CustomerPaymentComponent } from './customer-payment.component';
import { CustomerPaymentStates }    from './customer-payments.states';
import { SharedModule }            from '../../../app-lite/shared/shared.module';

@NgModule({
  declarations: [CustomerPaymentComponent],
  entryComponents: [CustomerPaymentComponent],
  imports: [SharedModule, UIRouterModule.forChild({ states: CustomerPaymentStates })]
})
export class CustomerPaymentsModule {}
